import { render } from "./ServicesGeneral.vue?vue&type=template&id=6beaeb26"
import script from "./ServicesGeneral.vue?vue&type=script&lang=js"
export * from "./ServicesGeneral.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__